import { PRODUCT_CONFIG } from "./Config";
import { ProductPerformanceChart } from "./PerformanceChart";
import { PerformanceDatepicker } from "./Filters";
import { minMaxDateFromDataCollection } from "./Helper";

const messageBus = window;

export const performanceChart = () => ({
  loading: true,
  error: false,
  productPerformanceChartInstance: undefined,
  chart: {
    ["x-bind:class"]() {
      return this.loading ? PRODUCT_CONFIG.PRODUCT_CHART_LOADING_CLASS : "";
    },
  },

  async init() {
    this.productPerformanceChartInstance = new ProductPerformanceChart();
    await this.productPerformanceChartInstance.init();
    this.loading = false;

    const chartConfig = this.productPerformanceChartInstance.currentConfig;

    this.bindEvents();

    setTimeout(() => {
      this.$dispatch("performanceChartCreated", chartConfig);
    });
  },

  bindEvents() {
    messageBus.addEventListener(
      "performanceChartFilterChanged",
      async ({ detail }) => {
        this.error = false;
        this.loading = true;
        const { name, value } = detail;

        try {
          const { filter, response, error } =
            await this.productPerformanceChartInstance.handleFiltersChange({
              name,
              value,
            });
          this.loading = false;

          if (!Object.keys(response).length) {
            this.$dispatch("performanceChartDataLoadError", { error });
            return;
          }

          this.$dispatch("performanceChartDataLoaded", { response, filter });
        } catch (error) {
          console.log("catch err", error);
          this.error = true;
          this.loading = false;
          this.$dispatch("performanceChartDataLoadError", { error });
        }
      }
    );

    messageBus.addEventListener(
      "performanceChartDateRangeChanged",
      async ({ detail }) => {
        this.error = false;
        this.loading = true;

        try {
          const { startDate, endDate } = detail;
          const { response, error } =
            await this.productPerformanceChartInstance.handleDateChange({
              startDate,
              endDate,
            });
          this.loading = false;

          if (error || !Object.keys(response).length) {
            this.$dispatch("performanceChartDataLoadError", { error });
            return;
          }

          this.$dispatch("performanceChartDataLoaded", { response });
        } catch (error) {
          console.log("catch err", error);

          this.error = true;
          this.loading = false;
          this.$dispatch("performanceChartDataLoadError", { error });
        }
      }
    );

    messageBus.addEventListener(
      "performanceChartNoDataLoaded",
      ({ detail }) => {
        this.error = true;
      }
    );
  },
  reloadChartWithNewFilters(filter) {
    this.productPerformanceChartInstance.reload();
  },
});

export const performanceChartFilters = () => ({
  loading: false,
  datepickerInstance: null,
  pickerInstance: null,
  selectedFilter: {
    name: "all",
    value: "ALL",
  },
  startDate: null,
  endDate: null,
  init() {
    this.bindEvents();
  },
  bindEvents() {
    messageBus.addEventListener("performanceChartDataLoaded", ({ detail }) => {
      this.loading = false;

      if (detail.filter) {
        const { startDate, endDate, name } = detail.filter;

        if (name == "ALL") {
          this.changeCalendarDatesRange(
            new Date(this.minDate),
            new Date(this.maxDate)
          );
          return;
        }

        this.changeCalendarDatesRange(new Date(startDate), new Date(endDate));
      }
    });

    messageBus.addEventListener("performanceChartCreated", ({ detail }) => {
      const minDateInit = new Date(),
        maxDateInit = new Date();

      const { minDate, maxDate } = minMaxDateFromDataCollection(
        detail.data || {}
      );

      this.minDate = minDate || minDateInit;
      this.maxDate = maxDate || maxDateInit;

      this.performanceDatepicker = new PerformanceDatepicker();
      this.pickerInstance = this.performanceDatepicker.create({
        minDate: minDate,
        maxDate: maxDate,
      });

      this.changeCalendarDatesRange(this.minDate, this.maxDate);
    });

    messageBus.addEventListener(
      "performanceChartDataLoadError",
      ({ detail }) => {
        this.loading = false;
      }
    );
  },
  handleDateRangeChanged(dateFrom, dateTo) {
    this.changeCalendarDatesRange(dateFrom, dateTo);

    this.changeFilter({
      name: "",
      value: "",
    });

    dateFrom.setUTCHours(24, 0, 0, 0);
    dateTo.setUTCHours(24, 0, 0, 0);

    this.$dispatch("performanceChartDateRangeChanged", {
      startDate: dateFrom.toISOString(),
      endDate: dateTo.toISOString(),
    });
  },
  changeFilter(filterConfig) {
    this.selectedFilter = filterConfig;
  },
  changeCalendarDatesRange(rawDate1, rawDate2) {
    this.startDate = this.performanceDatepicker.formatDate(rawDate1, "dMMM");
    this.endDate = this.performanceDatepicker.formatDate(rawDate2, "dMMM");
  },
  filterTrigger({ name, value }) {
    return {
      ["x-bind:class"]() {
        return this.selectedFilter.value == value
          ? PRODUCT_CONFIG.PRODUCT_FILTER_ACTIVE_CLASS
          : "";
      },
      ["@click"]() {
        if (this.loading) return;

        this.changeFilter({
          name,
          value,
        });

        this.pickerInstance.clear();

        this.loading = true;
        this.$dispatch("performanceChartFilterChanged", { name, value });
      },
    };
  },
  datepicker: {
    ["@change"](event) {
      const selectedDates = this.pickerInstance.selectedDates;
      if (selectedDates[0] && selectedDates[1]) {
        this.handleDateRangeChanged(selectedDates[0], selectedDates[1]);
      }
    },
  },
});

messageBus.addEventListener("performanceChartCreated", ({ detail }) => {});
messageBus.addEventListener("performanceChartNoDataLoaded", ({ detail }) => {});
messageBus.addEventListener(
  "performanceChartFilterChanged",
  ({ detail }) => {}
);
messageBus.addEventListener("performanceChartDataLoaded", ({ detail }) => {});
messageBus.addEventListener(
  "performanceChartDataLoadError",
  ({ detail }) => {}
);
messageBus.addEventListener(
  "performanceChartDateRangeChanged",
  ({ detail }) => {}
);
